package org.btmonier.games.model

import kotlinx.serialization.Serializable

@Serializable
data class GameContent(
    val description: String = "",
    val features: List<String> = emptyList(),
    val controls: List<String> = emptyList()
)
